import { useEffect, useState } from 'react';
import toast, { ToastOptions, ValueOrFunction, Renderable, Toast, useToasterStore } from 'react-hot-toast';

type ToastArgs = { message: ValueOrFunction<Renderable, Toast>; options: ToastOptions };
export const useCustomToastQueue = (maxToasts: number, duration?: number) => {
    const [queue, setQueue] = useState<ToastArgs[]>([]);
    const { toasts } = useToasterStore();

    const addToastToQueue = (message: ValueOrFunction<Renderable, Toast>, options: ToastOptions = {}) => {
        setQueue((prevQueue) => [...prevQueue, { message, options }]);
    };

    const dismissToast = (id: string) => {
        toast.remove(id);
    }

    useEffect(() => {
        const availableSlots = maxToasts - toasts.length;

        if (availableSlots > 0 && queue.length > 0) {
            const toastsToShow = queue.slice(0, availableSlots);
            const remainingToasts = queue.slice(availableSlots);

            setTimeout(() => {
                toastsToShow.forEach((toastItem) => {
                    toast.custom(toastItem.message, { duration: duration || 2000, ...toastItem.options });
                });
                setQueue(remainingToasts);
            }, 1);
        }
    }, [toasts, queue]);

    return { addToastToQueue, dismissToast };
};